import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { LanguageProvider } from "./i18n/LanguageContext";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import Evolucionamos from "./components/Evolucionamos";
import Enfoque from "./components/Enfoque";
import Divisions from "./components/Divisions";
import Sectors from "./components/Sectors";
import Philosophy from "./components/Philosophy";
import Impact from "./components/Impact";
import CtaFinal from "./components/CtaFinal";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App bg-white text-[#1A1F2C] antialiased" data-testid="app-root">
        <Navigation />
        <main>
          <Hero />
          <Evolucionamos />
          <Enfoque />
          <Divisions />
          <Sectors />
          <Philosophy />
          <Impact />
          <CtaFinal />
          <Contact />
        </main>
        <Footer />
        <Toaster position="bottom-right" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
